import { m } from 'framer-motion';

function Ring(props: { index: number; size: number; color: string }) {
  const { index, size, color } = props;

  return (
    <m.div
      style={{
        height: size,
        width: size,
        borderRadius: size / 2,
        backgroundColor: color,
        position: 'absolute',
        zIndex: 0,
      }}
      animate={{
        scale: [1, 1.7, 1.3, 1],
        opacity: [1, 0.3, 0],
      }}
      initial={{ scale: 1, opacity: 1 }}
      exit={{ scale: 1, opacity: 1 }}
      transition={{
        duration: 2.5,
        ease: 'linear',
        repeat: Number.POSITIVE_INFINITY,
        delay: index,
      }}
    />
  );
}
export default Ring;
